import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-icon-button',
  imports: [],
  templateUrl: './icon-button.component.html',
  styleUrl: './icon-button.component.scss',
})
export class IconButtonComponent {
  @Input() public icon?: string;
  // eslint-disable-next-line @angular-eslint/no-output-native
  @Output() public click = new EventEmitter<void>();

  public onClick(event: MouseEvent | KeyboardEvent): void {
    this.click.emit();
    event.stopPropagation();
  }
}
